import React from "react";


import {
  Card,
  CardBody,
  Content,
  Grid,
  GridItem,
  List,
  ListItem,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";


import {
  ExternalLinkAltIcon
} from "@patternfly/react-icons";


import {
  studentDocuments
} from "./data/studentDocuments";


const StudentDocumentsPage = () => {
  return (
    <PageSection isWidthLimited>
      <Stack hasGutter>
        <StackItem>
          <Grid>
            <GridItem span={12} md={8} mdOffset={2}>
              <Content style={{ textAlign: "center" }}>
                <h1>Dokumenty ucznia</h1>

                <p>
                  Formularze, regulaminy i dokumenty związane z organizacją nauki.
                </p>
              </Content>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={10}
              mdOffset={1}
              lg={8}
              lgOffset={2}
            >
              <Card isGlass>
                <CardBody>
                  <Content>
                    <List isPlain>
                      {studentDocuments.map((document) => (
                        <ListItem key={document.id}>
                          <a
                            href={document.href}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {document.title}{" "}
                            <ExternalLinkAltIcon />
                          </a>
                        </ListItem>
                      ))}
                    </List>
                  </Content>
                </CardBody>
              </Card>
            </GridItem>
          </Grid>
        </StackItem>
      </Stack>
    </PageSection>
  );
};


export default StudentDocumentsPage;